import { PricesAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import {
  IBaseUpdatePriceDTO,
  IUpdateAppraiserPriceDTO,
  TGetAppraiserPriceResponse,
  TGetPriceBaseResponse,
  TUpdateAppraiserPriceResponse,
  IUpdatePhotoShootingPriceDTO,
  TGetPhotoShootingPriceResponse,
  TUpdatePhotoShootingPriceResponse,
  TCreatePhotoShootingPriceDTO,
  IAppraiserPriceDTO,
  TUpdateSettlementDataResponse,
  IUpdateSettlementDataDTO,
} from '@/models/prices.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PRICES_SLICE_NAME } from './models';

export const getAppraisePrice = createAsyncThunk<TGetAppraiserPriceResponse, void, { serializedErrorType: IApiError }>(
  `${PRICES_SLICE_NAME}/getAppraisePrice`,
  async () => {
    const response = await PricesAPI.getAppraisePrice();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateAppraisePrice = createAsyncThunk<
  TUpdateAppraiserPriceResponse,
  IUpdateAppraiserPriceDTO,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/updateAppraisePrice`,
  async (data) => {
    const response = await PricesAPI.updateAppraisePrice(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getSettlementData = createAsyncThunk<
  TUpdateSettlementDataResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/getGeneralSettings`,
  async () => {
    const response = await PricesAPI.getSettlementData();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateSettlementData = createAsyncThunk<
  TUpdateSettlementDataResponse,
  IUpdateSettlementDataDTO,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/updateSettlementData`,
  async (data) => {
    const response = await PricesAPI.updateSettlementData(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getDocumentsPrice = createAsyncThunk<TGetPriceBaseResponse, void, { serializedErrorType: IApiError }>(
  `${PRICES_SLICE_NAME}/getDocumentsPrice`,
  async () => {
    const response = await PricesAPI.getDocumentsPrice();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateDocumentsPrice = createAsyncThunk<
  TGetPriceBaseResponse,
  IBaseUpdatePriceDTO,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/updateDocumentsPrice`,
  async (data) => {
    const response = await PricesAPI.updateDocumentsPrice(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getPhotoShootingPrice = createAsyncThunk<
  TGetPhotoShootingPriceResponse,
  void,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/getPhotoShootingPrice`,
  async () => {
    const response = await PricesAPI.getPhotoShootingPrice();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updatePhotoShootingPrice = createAsyncThunk<
  TUpdatePhotoShootingPriceResponse,
  IUpdatePhotoShootingPriceDTO,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/updatePhotoShootingPrice`,
  async (data) => {
    const response = await PricesAPI.updatePhotoShootingPrice(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deletePhotoShootingPrice = createAsyncThunk<
  TUpdatePhotoShootingPriceResponse,
  string,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/deletePhotoShootingPrice`,
  async (id) => {
    const response = await PricesAPI.deletePhotoShootingPrice(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createPhotoShootingPrice = createAsyncThunk<
  TUpdatePhotoShootingPriceResponse,
  TCreatePhotoShootingPriceDTO,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/createPhotoShootingPrice`,
  async (data) => {
    const response = await PricesAPI.createPhotoShootingPrice(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateAppraiserPrice = createAsyncThunk<
  TUpdateAppraiserPriceResponse,
  IUpdatePhotoShootingPriceDTO,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/updateAppraiserPrice`,
  async (data) => {
    const response = await PricesAPI.updateAppraiserPrice(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteAppraiserPrice = createAsyncThunk<
  TUpdateAppraiserPriceResponse,
  string,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/deleteAppraiserPrice`,
  async (id) => {
    const response = await PricesAPI.deleteAppraiserPrice(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createAppraiserPrice = createAsyncThunk<
  TUpdateAppraiserPriceResponse,
  IAppraiserPriceDTO,
  { serializedErrorType: IApiError }
>(
  `${PRICES_SLICE_NAME}/createAppraiserPrice`,
  async (data) => {
    const response = await PricesAPI.createAppraiserPrice(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
